/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreateAppointmentAfter/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function CreateAppointmentAfter({
  children,
  viewPath = "/DesignSystem/TimelineEvent/FutureSeparator/Actions/AddAppointment/Add/Content/AppointmentTypes/Content/CreateAppointmentAfter",
  onChange
  
}) {
let addAppointmentPreviousAppointmentIdValueData = fromData.useDataFormat({ viewPath,
context: 'add_appointment',
path: 'previous_appointment_id',
format: fromFormat.not,
})
let futureAppointmentsValueData = fromData.useDataValue({ viewPath,
context: 'future_appointments',
})
let addAppointmentPreviousAppointmentIdValueData1 = fromData.useDataValue({ viewPath,
context: 'add_appointment',
path: 'previous_appointment_id',
})
let addAppointmentPreviousAppointmentIdChangeData = fromData.useDataChange({ viewPath,
context: 'add_appointment',
path: 'previous_appointment_id',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 data="add_appointment.previous_appointment_id"
 format="/Data/format.js not"
 allowEmptyChoice={addAppointmentPreviousAppointmentIdValueData}
 marginTop={dtSpaceM}
 marginLeft={dtSpaceXs}
 data="future_appointments"
 from={futureAppointmentsValueData}
 data="add_appointment.previous_appointment_id"
 value={addAppointmentPreviousAppointmentIdValueData1}
 onChange={addAppointmentPreviousAppointmentIdChangeData}
 required={true}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Create appointment after"
/>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}